import { PointsExchangeIcon } from "src/assets/Icons";
import i18n from "src/i18n";
import { formatDate, formatNumber } from "src/utility";
import type { DataMap } from "../../../OrderCard/constants";
import type { UserOrderItem } from "../../../../constants";

type PointsExchangeOrderItem = UserOrderItem<"PointsExchange">;

const POINTS_EXCHANGE_ICON = (
  <div className="rounded-xl bg-background-minimal p-3" aria-hidden="true">
    <PointsExchangeIcon className="text-font-active" aria-hidden="true" />
  </div>
);

const POINTS_CARD_DATA_MAP = {
  referenceNumber: {
    get label() {
      return i18n.t("UserHistory.ordersList.referenceNumber");
    },
  },
  orderedAt: {
    get label() {
      return i18n.t("UserHistory.ordersList.exchangeDate");
    },
    value: (val: string) => formatDate(val, "YYYY-MM-DD, hh:mm A"),
  },
  points: {
    get label() {
      return i18n.t("UserHistory.ordersList.pointsUsed");
    },
    value: (val: number) => (
      <span className="text-font-active">
        {formatNumber(val)}
        {i18n.t("UserHistory.ordersList.pts")}
      </span>
    ),
  },
} satisfies DataMap;

export type { PointsExchangeOrderItem };
export { POINTS_EXCHANGE_ICON, POINTS_CARD_DATA_MAP };
